import {FC} from "react";

export const Paragraph: FC<{children: React.ReactNode}> = ({children}) => {
  return <p className={"text-sm text-brand-on-surface mb-4"}>{children}</p>
}
